module.exports = __webpack_public_path__ + "static/media/facebook-icon.8272b10d.svg";